
import { SyllabusAction } from '../types/SyllabusAction';
import ContentStatusData from '../types/ContentStatusData';
import { type } from 'os';

const fetchSubjects = (data: any = {}) => (dispatch: any) => {
 const request = (payload: any[]): SyllabusAction =>
    ({ type: 'FETCH_SUBJECTS', payload });
  // const success = (data: any[]): SyllabusAction =>
  //   ({ type: 'FETCH_SUBJECTS_SUCCESS', data });
  // const failure = (error: string): SyllabusAction =>
  //   ({ type: 'FETCH_SUBJECTS_FAILED', error: '' });
    dispatch(request(data))
}

const updateSubject = (data: any = {}) => (dispatch: any) => {
  const request = (payload: any[]): SyllabusAction =>
  ({ type: 'UPDATE_SUBJECT', payload });
    // const success = (data: any[]): SyllabusAction =>
    //   ({ type: 'UPDATE_SUBJECT_SUCCESS', data });
    // const failure = (error: string): SyllabusAction =>
    //   ({ type: 'UPDATE_SUBJECT_FAILED', payload: '' });
    dispatch(request(data))
  }

  
  const getRandomQuestions = (data: any = {}) => (dispatch: any) => {
    const request = (payload: any[]): SyllabusAction =>
    ({ type: 'GET_AUTO_GENERATE', payload });
      dispatch(request(data))
    }

const syllabusActions = {
  fetchSubjects,
  updateSubject,
  getRandomQuestions
};

export default syllabusActions;